import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import type { SessionUser } from '../lib/api'

/**
 * The session, the apps/web way: one device token in localStorage (docs/CONTRACT.md §2 — the
 * token is the only credential and no cookie is involved, so nothing is done on the server), and
 * the user row it belongs to, so a reload can render before `/api/me` answers. `status` and
 * `isAdmin` ride on the user (§6): the whole console branches on them.
 */
interface AuthState {
  token: string | null
  user: SessionUser | null
  setSession: (token: string, user: SessionUser) => void
  setUser: (user: SessionUser) => void
  clearSession: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      setSession: (token, user) => set({ token, user }),
      setUser: (user) => set({ user }),
      clearSession: () => set({ token: null, user: null }),
    }),
    {
      name: 'olmt-call.admin.session',
      version: 1,
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ token: state.token, user: state.user }),
    },
  ),
)
